import React from 'react'
import { FeedItem } from '../../../../Api'
import { ContentFeed } from './ContentFeed'
import { Box } from '../../../../Components/Layout'

type HomeLatestList = {
  mainFeed: FeedItem[]
}

export const ContentFeedList: React.FC<HomeLatestList> = ({ mainFeed }) => {
  return (
    <>
    <Box>
      <ContentFeed
        contentType={'article'}
        feedItems={mainFeed}
        section="home_latest_article_box_1"
      /></Box>
      <Box>
      <ContentFeed
        contentType={'video'}
        feedItems={mainFeed}
        section="home_latest_video_box_1"
      />
    </Box>
    </>
  )
}
